const reducerTermosUsoTypes = {
    SET_TERMOS_USO: "setTermosUso",
    GET_TERMOS_USO: "getTermosUso",
}

const reducerTermosUso = (state = {termosUso: {termos: ""}, reducerTermosUsoTypes: reducerTermosUsoTypes}, {type, payload}) => {
switch(type){
        case 'setTermosUso':
            return Object.assign({}, state, {termosUso:payload});
        case 'getTermosUso':
            return {
                ...state
            }
        default:
            return state;
    }
};



/* const defaultState = {pedido: {itens:[]}}; */
//export default {reducerPedido, defaultState, reducerPedidoTypes};
export default reducerTermosUso;